import { getLatestState, updateState, defaultState } from '../gameState'
import resetGameState from '../helpers/resetGameState'
import { sounds } from './sound'

let gameOverTime = 0

export default () => {
	const { gameOver } = getLatestState()
	if (gameOver && !gameOverTime) {
		gameOverTime = performance.now() + 5000
		sounds.rip()
	}

	if (gameOver && gameOverTime - 800 < performance.now()) document.body.classList.add('flash')

	if (gameOver && gameOverTime < performance.now()) {
		document.body.classList.remove('flash')
		gameOverTime = 0
		resetGameState()
	}
}
